<template>
  <div class="headerDivWrap">
    <div class="headerTopDiv":class="{ 'en': $i18n.locale == 'en' }">
      <div class="logoDiv">
        <img src="@/assets/homePage/logo.png" alt="">
        <div class="name">
          <div class="zh">{{ $t('company.name') }}</div>
<!--          <div class="en">Beijing Shunfuda Logistics Co., Ltd</div>-->
        </div>
      </div>
      <div class="navgateDiv">
        <div class="item" v-for="item in navLists" :key="item.index" @click="goPosition(item.path)">
          {{ $t(`navgate.item${item.index}`) }}
        </div>
        <div class="switchBtn" :class="{ 'en': $t('language.name') == 'English' }">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $t('language.name') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'headerAll',
  components: { },
  data () {
    return {
      navLists: [
        { index: 1, name: this.$t('navgate.item1'), path: 'aboutUs' },
        { index: 2, name: this.$t('navgate.item2'), path: 'advantage' },
        { index: 3, name: this.$t('navgate.item3'), path: 'develop' },
        { index: 4, name: this.$t('navgate.item4'), path: 'client' },
        { index: 5, name: this.$t('navgate.item5'), path: 'vehicle' }
      ]
    }
  },
  mounted () {
  },
  methods: {
    goPosition (id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
    },
    changeLanguage () {
      console.log(this.$i18n)
      this.$i18n.locale == 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh'   //设置中英文模式
      localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
    handleCommand(command) {
      console.log(command)
      this.$i18n.locale = command   //设置中英文模式
      localStorage.setItem('languageSet',command)
    }
  }
}
</script>

<style lang="scss">
$themeColor: #990000;
.headerDivWrap {
  width: 100%;
  min-width: 1200px;
  //height: 100px;
  //top: 0;
  //left: 0;
  //z-index: 99;
  //position: fixed;
  //background: #fff;
  .headerTopDiv {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 100px;
    .logoDiv {
      display: flex;
      img {
        height: 60px;
        margin-top: 20px;
      }
      .name {
        margin-top: 35px;
        margin-left: 10px;
        .zh {
          color: #333;
          font-size: 20px;
        }
        .en {
          color: rgb(207, 209, 210);
          font-size: 14px;
          margin-left: 2px;
        }
      }
    }
    .navgateDiv {
      display: flex;
      justify-content: space-between;
      .item {
        width: 138px;
        color: #333;
        text-align: center;
        font-size: 16px;
        line-height: 100px;
        cursor: pointer;

      }
      .item:hover {
        background-color: $themeColor;
        color: #fff;
      }
      .switchBtn {
        cursor: pointer;
        margin-top: 37px;
        margin-left: 40px;
        width: 75px;
        .el-dropdown {
          font-size: 16px;
          color: #333;
        }
      }
      .switchBtn.en {
        margin-top: 40px;
      }
    }
  }
  .headerTopDiv.en {
    .logoDiv {
      .name {
        margin-top: 38px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homePage/headerAll.vue